import { useState } from "react";
import { markWelcome } from "../components/onboarding/WelcomeDialog";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../store/AuthContext";
import { OnboardingShell } from "./AuthPage";
import { CheckoutPanel } from "../components/onboarding/CheckoutPanel";

// Account exists but the subscription hasn't been paid yet - the app stays locked until the card goes through.
export default function PaymentGate({ demo = false }) {
  const { user, refresh, signOut, setPreviewAs } = useAuth();
  const [plan, setPlan] = useState(user.plan_intent === "yearly" ? "yearly" : "monthly");
  const onPaid = async (u) => { markWelcome(plan); await refresh(); const key = u?.license_key || user.license_key; toast.success(`Welcome to Xpattern ${plan === "yearly" ? "Yearly" : "Monthly"} — you now have full access!`, { duration: 15000, description: `Your license key: ${key}. It is attached to your profile, this computer and your connected plotter and cannot be used with another account or computer. A copy has been emailed to ${user.email}.` }); };
  return (
    <OnboardingShell wide title="Complete your payment" subtitle={`Hi ${user.name || user.shop_name}. Your account is created — add a card to unlock Xpattern.`} noLogo>
      <CheckoutPanel plan={plan} setPlan={setPlan} onPaid={onPaid} demo={demo} email={user.email} />
      <button data-testid="gate-signout" onClick={demo ? () => setPreviewAs("first_launch") : signOut} className="mt-4 flex w-full items-center justify-center gap-1 text-[11px] text-[#6b7079] hover:text-[#e8e9ec]"><LogOut className="h-3 w-3" /> Not you? Sign out</button>
    </OnboardingShell>
  );
}
